import { prefix as prefixBase } from '../../constants'
export const prefix = `${prefixBase}.learningPaths`
